import axios from 'services/axios';

const BASE_API_URL = import.meta.env.VITE_APP_API_URL;
const DEFAULT_CNH_BASE_IDENTITY_URL = import.meta.env.VITE_APP_CNH_BASE_IDENTITY_URL ?? '';
const DEFAULT_CNH_BASE_AUDIENCE_URL = import.meta.env.VITE_APP_CNH_BASE_AUDIENCE_URL ?? '';
const CNH_CONNECTION = import.meta.env.VITE_APP_CNH_CONNECTION ?? '';

export const getCNHOrgs = async (user_id: string, org_id: string) => {
  try {
    const response: any = await axios.request({
      method: 'GET',
      url: `${BASE_API_URL}/valet/v2/cnh-companies`,
      params: {
        user_id,
        org_id,
      },
    });
    if (!response?.data?.companies) return [];
    return response.data.companies.map((company: any) => {
      return {
        name: company.companyName,
        id: company.companyId,
      };
    });
  } catch (err: any) {
    const details = 'Failed to get CNH data:';
    console.error(details, err);
    return err;
  }
};

export default class CNH {
  CNH_BASE_IDENTITY_URL: string = DEFAULT_CNH_BASE_IDENTITY_URL;
  CNH_BASE_AUDIENCE_URL: string = DEFAULT_CNH_BASE_AUDIENCE_URL;
  BASE_URL: string = window.origin;
  CLIENT_ID: string;
  CLIENT_SECRET: string;
  _token: string = '';

  constructor(
    CLIENT_ID: string,
    CLIENT_SECRET: string,
    BASE_URL?: string,
    CNH_BASE_IDENTITY_URL?: string,
    CNH_BASE_AUDIENCE_URL?: string,
  ) {
    this.CLIENT_ID = CLIENT_ID;
    this.CLIENT_SECRET = CLIENT_SECRET;
    if (BASE_URL) this.BASE_URL = BASE_URL;
    if (CNH_BASE_IDENTITY_URL) this.CNH_BASE_IDENTITY_URL = CNH_BASE_IDENTITY_URL;
    if (CNH_BASE_AUDIENCE_URL) this.CNH_BASE_AUDIENCE_URL = CNH_BASE_AUDIENCE_URL;
  }

  init(_params?: object) {
    const defaultParams = {
      client_id: this.CLIENT_ID,
      scope: 'offline_access',
      redirect_uri: `${this.BASE_URL}/callback/cnh`,
      response_type: 'code',
      audience: this.CNH_BASE_AUDIENCE_URL,
      connection: CNH_CONNECTION,
    };
    let finalParams = defaultParams;
    if (_params) {
      finalParams = {
        ...defaultParams,
        ..._params,
      };
    }
    const params = new URLSearchParams(finalParams);
    const url = `${this.CNH_BASE_IDENTITY_URL}/authorize?${params.toString()}`;
    window.location.replace(url);
  }
  async getOrganizations(user_id: string, org_id: string) {
    return getCNHOrgs(user_id, org_id);
  }
}
